import { useState,useRef } from "react";
import { NavLink } from "react-router-dom";
import insertNewLines from "../../../../../utilities/insertNewLines";
import DelayedText1 from "../../../../About/components/DelayedText1";
import scrollToTop from "../../../../../utilities/scrollToTop";

function Logical_Operators() {
  const title = 'Logical Operators'

  const paragraphs = {

    first: [insertNewLines(`Logical operators allow for multiple tests, within the same if statement $4$@@$4$
    1 - *and* operator - *&&*:$4$@@$4$
    this operator makes it so that the test is true ONLY if  BOTH tests, before and after the && operator are true, there isn’t a limit to the number of simultaneous tests, here’s an example:$4$@@$4$
    >>$4$@@$4$
    let a = 1;$4$@@$4$
    let b = 2;$4$@@$4$
    let c;$4$@@$4$
    if( a == 1 && b == 1) {$4$@@$4$
    $4$%%$4$c = 3$4$@@$4$
    }$4$@@$4$
    <<$4$@@$4$
    in the example above, both a AND b have to equal 1 in order for c to be given the value of 3, and since b != 1, c will remain uninitialized$4$@@$4$
    $4$@@$4$
    2 - *or* operator - *||*:$4$@@$4$
    this operator makes it so that the test is true if the either tests before OR after the || operator are true, there isn’t a limit to the number of simultaneous tests, here’s an example:$4$@@$4$
    >>$4$@@$4$
    let a = 1;$4$@@$4$
    let b = 2;$4$@@$4$
    let c;$4$@@$4$
    if(a == 1 || b == 1){$4$@@$4$
    $4$%%$4$c = 3;$4$@@$4$
    }$4$@@$4$
    <<$4$@@$4$
    in the given example, the tests requires for either a OR b to equal 1, since one of them (a) equals 1, the code is executed and c is given the value of 3`)],

    second: [],

    third: [],

    forth: [],

    fifth: [],

    sixth: [],

    seventh: [],
  }

  const [colorMode,setColorMode] = useState(JSON.parse(localStorage.getItem("lightMode")))

  function handleColorModeClick(){
    localStorage.setItem("lightMode", JSON.stringify(!colorMode))
      setColorMode(JSON.parse(localStorage.getItem("lightMode")))
  }
  
  return (
    <div  className={colorMode ? 'BlogPage lightMode' : 'BlogPage'}>
      <button className='blog-page-color-mode-btn' onClick={handleColorModeClick} >
      {colorMode && <DelayedText1 type={69} content="DAY MODE" typeSpeed={50} characterIterations={3} switch={false}/>}
      {!colorMode && <DelayedText1 type={69} content="NIGHT MODE" typeSpeed={50} characterIterations={3} switch={false}/>}
      </button>
      <div className="key-container">
          <div>
              <h3>Key:</h3>
              <h4><span>{">> ... <<"}</span> <span>: literal code example</span></h4>
              <h4><span>{"> ... <"}</span> <span>: pseudo code example</span></h4>
              <h4><span>{"- ... -"}</span> <span>: quoting a string/value</span></h4>
              <h4><span>{"-- ... --"}</span> <span>: quoting a symbol</span></h4>
          </div>
        </div>
        <h1>{title}</h1>
        <hr className="splitter-hr"/>
        <div className='blog-page-container' >
          {paragraphs.first.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.first[0] && <hr className="splitter-hr"/>}

          {paragraphs.second.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.second[0] && <hr className="splitter-hr"/>}

          {paragraphs.third.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.third[0] && <hr className="splitter-hr"/>}

          {paragraphs.forth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.forth[0] && <hr className="splitter-hr"/>}

          {paragraphs.fifth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.fifth[0] && <hr className="splitter-hr"/>}

          {paragraphs.sixth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.sixth[0] && <hr className="splitter-hr"/>}

          {paragraphs.seventh.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.seventh[0] && <hr className="splitter-hr"/>}
        </div>
        <div className='back-nav-container'>
        <NavLink to='/blog' onClick={scrollToTop}><button className="blog-return-btn" >BACK TO BLOG</button></NavLink>
        </div>
    </div>
  );
  }
  
  export default Logical_Operators;
  